/* Trust badges slider: auto-advances a scroll-snap row. No work while off screen, hidden, hovered or touched. */
(() => {
  if (customElements.get('tt-trust-slider')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  class TrustSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tbs-track]');
      if (!this.track || reduce || this.dataset.autoplay !== 'true') return;
      this.ms = Math.max(2, parseInt(this.dataset.interval) || 3) * 1000;
      this.visible = false; this.paused = false;
      const pause = () => { this.paused = true; }, resume = () => { this.paused = false; };
      this.addEventListener('pointerenter', pause); this.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', pause); this.addEventListener('focusout', resume);
      this.track.addEventListener('touchstart', () => { this.paused = true; clearTimeout(this._t); this._t = setTimeout(resume, 6000); }, { passive: true });
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; }, { threshold: 0.3 });
      this.io.observe(this);
      this.timer = setInterval(() => this.step(), this.ms);
    }
    disconnectedCallback() { clearInterval(this.timer); this.io?.disconnect(); }
    step() {
      if (!this.visible || this.paused || document.hidden) return;
      const t = this.track, first = t.firstElementChild;
      if (!first || t.scrollWidth <= t.clientWidth + 2) return;
      const gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      const w = first.getBoundingClientRect().width + gap;
      const atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      t.scrollTo({ left: atEnd ? 0 : t.scrollLeft + w, behavior: 'smooth' });
    }
  }
  customElements.define('tt-trust-slider', TrustSlider);
})();
